// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccount --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {
  Exact,
  OpenapiAccountBusinessTypeEnum,
  OpenapiAccountObjectFieldType,
  OpenapiAccountTypeEnum,
} from '@stripe-internal/data-v1/schema/types';
import {bankAccountExternalAccountFragment} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/bankAccountExternalAccountFragment';
import {cardExternalAccountFragment} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/cardExternalAccountFragment';
import {blockchainAddressExternalAccountFragment} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/blockchainAddressExternalAccountFragment';
import {financialAccountBalanceExternalAccountFragment} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/financialAccountBalanceExternalAccountFragment';
import type {BlockchainAddressExternalAccountFragmentData} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/blockchainAddressExternalAccountFragment';
import type {CardExternalAccountFragmentData} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/cardExternalAccountFragment';
import type {BankAccountExternalAccountFragmentData} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/bankAccountExternalAccountFragment';
import type {FinancialAccountBalanceExternalAccountFragmentData} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/financialAccountBalanceExternalAccountFragment';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {stripeAccountBusinessProfileFragment} from './stripeAccountBusinessProfileFragment';
import {stripeLegalEntityCompanyFragment} from './stripeLegalEntityCompanyFragment';
import {stripeLegalEntityIndividualFragment} from './stripeLegalEntityIndividualFragment';
import {stripeAccountSettingsFragment} from './stripeAccountSettingsFragment';
import {stripeAccountRequirementsFragment} from './stripeAccountRequirementsFragment';

import type {StripeAccountBusinessProfileFragmentData} from './stripeAccountBusinessProfileFragment';
import type {StripeLegalEntityCompanyFragmentData} from './stripeLegalEntityCompanyFragment';
import type {StripeLegalEntityIndividualFragmentData} from './stripeLegalEntityIndividualFragment';
import type {StripeAccountRequirementsFragmentData} from './stripeAccountRequirementsFragment';
import type {StripeAccountSettingsFragmentData} from './stripeAccountSettingsFragment';

const doc = gql`
  fragment StripeAccountFragment on OpenapiAccount {
    business_dba
    business_profile {
      ...StripeAccountBusinessProfileFragment
    }
    business_type
    charges_enabled
    company {
      ...StripeLegalEntityCompanyFragment
    }
    country
    created
    default_account_holder_name
    default_currency
    details_submitted
    external_accounts {
      data {
        ...BlockchainAddressExternalAccountFragment
        ...CardExternalAccountFragment
        ...BankAccountExternalAccountFragment
        ...FinancialAccountBalanceExternalAccountFragment
      }
    }
    id
    individual {
      id
      ...StripeLegalEntityIndividualFragment
    }
    object
    payouts_enabled
    requirements {
      ...StripeAccountRequirementsFragment
    }
    settings {
      ...StripeAccountSettingsFragment
    }
    type
  }

  ${stripeAccountBusinessProfileFragment}
  ${stripeLegalEntityCompanyFragment}
  ${stripeLegalEntityIndividualFragment}
  ${stripeAccountSettingsFragment}
  ${stripeAccountRequirementsFragment}
  ${bankAccountExternalAccountFragment}
  ${blockchainAddressExternalAccountFragment}
  ${cardExternalAccountFragment}
  ${financialAccountBalanceExternalAccountFragment}
`;

export const stripeAccountFragment: StripeAccountFragmentDocument = doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountFragmentData = {
  readonly __typename: 'OpenapiAccount';
  readonly business_dba: string | null;
  readonly business_type: OpenapiAccountBusinessTypeEnum | null;
  readonly charges_enabled: boolean;
  readonly country: string;
  readonly created: number | null;
  readonly default_account_holder_name: string | null;
  readonly default_currency: string;
  readonly details_submitted: boolean;
  readonly id: string;
  readonly object: OpenapiAccountObjectFieldType;
  readonly payouts_enabled: boolean;
  readonly type: OpenapiAccountTypeEnum;
  readonly business_profile: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountBusinessProfile'},
    [StripeAccountBusinessProfileFragmentData]
  > | null;
  readonly company: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityCompany'},
    [StripeLegalEntityCompanyFragmentData]
  > | null;
  readonly external_accounts: {
    readonly __typename: 'OpenapiAccountExternalAccounts';
    readonly data: ReadonlyArray<
      GraphQlFragmentUnion<
        | {
            readonly __typename: 'OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddress';
          }
        | {readonly __typename: 'OpenapiExternalAccountBankAccount'}
        | {readonly __typename: 'OpenapiExternalAccountCard'}
        | {
            readonly __typename: 'OpenapiExternalAccountFinancialAccountBalance';
          },
        [
          BlockchainAddressExternalAccountFragmentData,
          CardExternalAccountFragmentData,
          BankAccountExternalAccountFragmentData,
          FinancialAccountBalanceExternalAccountFragmentData,
        ]
      >
    >;
  } | null;
  readonly individual: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityIndividual'; readonly id: string},
    [StripeLegalEntityIndividualFragmentData]
  > | null;
  readonly requirements: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountRequirements'},
    [StripeAccountRequirementsFragmentData]
  > | null;
  readonly settings: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountSettings'},
    [StripeAccountSettingsFragmentData]
  > | null;
};

export type StripeAccountFragmentVariables = Exact<{[key: string]: never}>;

const stripeAccountFragmentPermissions = {
  ...bankAccountExternalAccountFragment.permissions,
  ...blockchainAddressExternalAccountFragment.permissions,
  ...cardExternalAccountFragment.permissions,
  ...financialAccountBalanceExternalAccountFragment.permissions,
  ...stripeAccountBusinessProfileFragment.permissions,
  ...stripeAccountRequirementsFragment.permissions,
  ...stripeAccountSettingsFragment.permissions,
  ...stripeLegalEntityCompanyFragment.permissions,
  ...stripeLegalEntityIndividualFragment.permissions,
} as const;

doc.permissions = stripeAccountFragmentPermissions;

export type StripeAccountFragmentPermissions = V1PermissionToken<
  typeof stripeAccountFragmentPermissions
>;

export type StripeAccountFragmentDocument = GraphQlDocument<
  StripeAccountFragmentData,
  StripeAccountFragmentVariables,
  StripeAccountFragmentPermissions
>;
